import { Metafield } from '@portal/processes/ShopV2/ShopV2.types';

const isMetafield = (x: unknown): x is Metafield => !!x && typeof (x as any).key === 'string';

// some metafields come back null - compact it and then operate on clean data
export const compactMetafields = (
  list: readonly (Metafield | null | undefined)[] | null | undefined
): Metafield[] => (list ?? []).filter(isMetafield);

export function getMetafield(
  metafields: readonly Metafield[] | undefined,
  key: string,
  namespace: string | null | undefined = 'custom'
): Metafield | null {
  return (
    compactMetafields(metafields).find(
      (m) => m.key === key && (namespace === null || m.namespace === namespace)
    ) ?? null
  );
}
